import {useState,useEffect} from 'react'
import {Box, TextField, FormControl, Tooltip, LinearProgress,
    FormControlLabel, FormLabel, RadioGroup, Checkbox, Card,
    Typography, Radio,
    InputLabel,
    Select,
    MenuItem,
    FormGroup,
    Divider} from '@material-ui/core'  
import Autocomplete from "@material-ui/lab/Autocomplete";
import axios from 'axios';
import qs from 'qs';
import { useHistory } from "react-router-dom";
import Modal from '../generales/ModalCerrarActualiza';
import {llamadaApiToken,ErrorGeneral,llamadaApiCarga,llamaApiCargaToken } from '../funciones/ClienteAxios';
import { toast } from 'react-toastify'; 
import { obtenDispo } from '../funciones/IdDispositivo';

const ModalPerfilv2 = ({modalAbierto,setModalAbierto ,titulo,listPlantilla,setNvoRegisPerfil, }) => {
    let history = useHistory();      
    const auxDispV =obtenDispo() 
    const source = axios.CancelToken.source();   
    const usuId =localStorage.getItem('UsuId') ;  
    const[perfil,setPerfil]= useState({Nombre:'',calle:'', Tel:'', Municipio:null, plantilla:0,
                                        edo:null,genero:"", apPat:"", apMat:"",
                                        edad:"", pregunta1:"", pregunta2:"", pregunta3:"", preguntaext:"", percepcion:"",
                                        Barrio:"", 
                                        });      
    const [espera,setEspera]= useState(false);
    const [mensaje, setMensaje] = useState("");
    const [tipoAdvertencia, setTipoAdvertencia] = useState("success");
    const [btnDeshabilitado,setBtnDeshabilitado]= useState(true)
    const [aviso, setAviso] = useState(false);    
    const[posicion,setPosicion]= useState({Lat:0,Lon:0})
    const[mensajePos,setMensajePos]= useState("")
    const[cambioEfectivo,serCambioEfectivo] = useState(false)    
    const[nvoRegistro, setNvoRegistro] = useState([])       
    const[listMun, setListMun] = useState([])     
    const[listBarrio, setListBarrio] = useState([])     
    const[listChecks, setListChecks] = useState({ opPrec1:false, opPrec2:false, opPrec3:false, opPrec4:false, opPrec5:false,
                                        opPrec6:false})    
    const[btnLeyenda, setBtnLeyenda] = useState("Guardar")        
    const{opPrec1, opPrec2, opPrec3, opPrec4, opPrec5, opPrec6}=listChecks
    const{Nombre,  calle, Tel, Municipio, genero, apPat, apMat,  edad,
        pregunta1, pregunta2, pregunta3, preguntaext, percepcion, Barrio,        
    }=perfil
    

    useEffect(()=>{   
       
        setPerfil({...perfil,plantilla:listPlantilla[0].Id,
           // edo: localStorage.getItem('prflEdo')??null,            
        })
        getLocation()
        getListMuni(15)
        //getListBarrio()
     
    },[])   

    function getLocation() {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(showPosition);
        } 
        else 
        {   setMensajePos( "La Geolocalizacion no es soportada por tu navegador.");
            setPosicion([])
        }
    }
      
    function showPosition(position) {
        let Latitude= position.coords.latitude ;
        let Longitude= position.coords.longitude;
        setPosicion({Lat:Latitude,Lon:Longitude})
    }

    function getListMuni(auxEdo)  {            
        const url= `lugar/seccion`;                            
        const data = qs.stringify({                
            Usuario:usuId,              
            Estado:auxEdo,                                                
            ip:"127.0.0.0",
            idDispositivo:auxDispV,
        });
                    
        function respuesta (aux) 
        {   if (aux[0].Id != -1) 
            {   
                let listNvo=[]
                aux.forEach(element => {
                    listNvo.push({...element, cadena:`${element.Numero}`})
                });
                setListMun(listNvo) 
                //filtroMun(aux)               
            }  
            else{
                setListMun([])
            }                                                                    
        }
        llamadaApiToken(data, url, respuesta, ErrorGeneral, history, source);
    };

    function getListBarrio(auxEdo)  {            
        const url= `lugar/municipio/comuna/barrio`;                            
        const data = qs.stringify({                
            Usuario:usuId,              
            Estado:auxEdo,                                                
            ip:"127.0.0.0",
            idDispositivo:auxDispV,
        });
                    
        function respuesta (aux) 
        {   if (aux[0].Id != -1) 
            {   
               
                setListBarrio(aux)                 
            }  
            else{
                setListBarrio([])
            }                                                                    
        }
        llamadaApiToken(data, url, respuesta, ErrorGeneral, history, source);
    };

    const filtroMun=(aux)=>{
        if (localStorage.getItem('prflMuni')) 
        {
            const filtro=aux.filter((mun)=>mun.Id ===parseInt(localStorage.getItem('prflMuni'))) 
            setPerfil({...perfil,Municipio:filtro[0]??null})
        }else{
            setPerfil({...perfil,Municipio:null,Seccion:null})
        }       
    }

    const onChangeTxt = e =>
	{   let expNopermitida = new RegExp('[%{}*|`]');  
        let expMenos = new RegExp("'");
        let expMas = new RegExp('"');             
        let expCadena = new RegExp('[A-Za-z0-9$.@#_&-+()/:;!?,<>=]');  
        if ( ( expCadena.test(e.target.value) && !expNopermitida.test(e.target.value) 
                && !expMenos.test(e.target.value) && !expMas.test(e.target.value) ) 
                || e.target.value===' '|| e.target.value==='') 
        {
            setPerfil({...perfil,[e.target.name] : e.target.value})            
        }		
	};             

    const onChangeNom = e =>
	{   let expNopermitida = new RegExp('[0-9$.@#_&-+()/:;!?,<>=%{}*|`]');  
        let expMenos = new RegExp("'");
        let expMas = new RegExp('"');             
        let expCadena = new RegExp('[A-Za-z]');  
        if ( ( expCadena.test(e.target.value) && !expNopermitida.test(e.target.value) 
                && !expMenos.test(e.target.value) && !expMas.test(e.target.value) ) 
                || e.target.value===' '|| e.target.value==='') 
        {
            setPerfil({...perfil,[e.target.name] : e.target.value})            
        }		
	}; 

    const onChangeNumTel = e =>
	{   let expNopermitida= new RegExp('[A-Za-z$@#_&-+()/:;!?,<>=]');          
        let expMenos = new RegExp("'");
        let expMas = new RegExp('-');     
        let expCadena = new RegExp('[.0-9$]');             
        if (  e.target.value.length<=10 &&( expCadena.test(e.target.value) && !expNopermitida.test(e.target.value) 
            && !expMenos.test(e.target.value) && !expMas.test(e.target.value) ) 
            || e.target.value===' '|| e.target.value==='') 
        {
            setPerfil({ ...perfil,[e.target.name] : e.target.value })            
            if (e.target.value.length>=10) {
                setBtnDeshabilitado(false)                     
            }            
            else{
                setBtnDeshabilitado(true)                     
            }
        }		    
	}; 
     
    function getNvoPerfil(auxCadena )  {           
     
        const url=`perfil/v4/web/new`;                                                                                        
        const dataInfo = qs.stringify({                                                                               
            usuario:usuId,
            telefono:Tel,
            nombre:Nombre.trim(),    
            paterno:apPat.trim(),
            materno:apMat.trim(),
            latitud:posicion.length > 0 ? posicion.Lat : 0,
            longitud:posicion.length > 0 ? posicion.Lon : 0,
            direccion:calle,            
            plantilla:1,                                            
            seccion:Municipio.Id,      
            //barrio:Barrio,                  
            genero:genero,            
            domicilio:"",
            percepcion:percepcion,
            edad:edad,
            status:1,
            pregOp1:pregunta1,
            pregOp2:pregunta2,
            pregOp3:pregunta3,
            pregOp4:auxCadena,
            idDispositivo:auxDispV
        });

        function respuesta (aux) {                                                                                 
            if (aux?.respuesta!==0) 
            {                               
                setBtnDeshabilitado(true)                                             
                const mensaje="Se registro correctamente el Perfil"
                setTipoAdvertencia("success")      
                setMensaje(mensaje);                
                setAviso(false);
                toast.success(mensaje,{
                    pauseOnFocusLoss: false,                    
                    toastId: `nvo-perfil${1}`
                })
                
                setNvoRegisPerfil({Nom:`${Nombre} ${apPat} ${apMat}`,llave:aux.mensaje, PlantId:1,                 })
                setModalAbierto(false);
                setNvoRegistro(aux)
                serCambioEfectivo(true) 
                
            }                                            
        }     
        llamaApiCargaToken(dataInfo, url, respuesta, ErrorGeneral, setEspera, history, source);  
    };

    const onChangeCorreo = e =>
	{   let expNopermitida = new RegExp('[$@#_&-+()/.;!?,<>=%{}*|`]');  
        let expMenos = new RegExp("'");
        let expMas = new RegExp('"');             
        let expCadena = new RegExp('[A-Za-z0-9]');  
        if ( ( expCadena.test(e.target.value) && !expNopermitida.test(e.target.value) && !expMenos.test(e.target.value) &&
            !expMas.test(e.target.value) ) || e.target.value===' '|| e.target.value==='') 
        { 
            setPerfil({ ...perfil, [e.target.name] : e.target.value.toUpperCase() })
            if (aviso) 
            {   setMensaje('');
                setAviso(false);
            }
        }		
	};     

    const verificaNulos = (campo,descripcion)=>{
        let respuesta =false;        
          
        if(campo===null|| (typeof campo !== 'number' && typeof campo === 'string' 
            && (campo.trim() === '' || campo.trim() === null) )
        ) 
        {   respuesta=true;                 
            setMensaje('No se lleno el campo '+descripcion);
            setTipoAdvertencia("warning")  
            setAviso(respuesta);
        }
        return(respuesta);
    }
  
    const mandaAlerta=(mensaje,tipoAdvert)=>
    {
        setMensaje(mensaje);
        setTipoAdvertencia(tipoAdvert)  
        setAviso(true);      
    }
      
    function validaVariable(auxCampo,auxMensaje,auxTamanio) 
    {   let respuesta=false
        if ( !verificaNulos(auxCampo,auxMensaje) ) 
        {   if (auxCampo.length>=auxTamanio ) 
            {                
                respuesta=true                    
            }else
            {            
                mandaAlerta('Campo '+auxMensaje +' incompleto, debe escribir un '+ auxMensaje+' valido',"warning") 
            }
        }        
        return respuesta;
    }
 
    const guardarMuni=(e)=>{    
        if (e!== null && e!== undefined) 
        {                            
            setPerfil({ ...perfil, Municipio : e  , Seccion :""  })      
            setMensaje('');                
            setAviso(false);             
            //localStorage.setItem('prflMuni',e.Id)    
             
        }else
        {   setPerfil({...perfil, Municipio : "" ,Seccion :""   })                       
        }        
    }

    const onchangeLocal=(e)=>{
        switch (e.target.name ) {
            case 'edo':                
                localStorage.setItem('prflEdo',e.target.value)     
                localStorage.removeItem("prflMuni")    
                
                break;
                                       
            default:
                break;
        }        
    }

    const onChangeSlct=(e)=>{            
         if (e!== null && e!== undefined) 
        {   setPerfil({...perfil,[e.target.name]:e.target.value})   
            
        }
        else
        {   setPerfil({...perfil,[e.target.name]:""})          
        }        
    }

    const onChangeGen = e =>
    {  
        setPerfil({ ...perfil, genero: e.target.value  })        
    };
    
    const onChangeCheck = (e) => {
        setPerfil({...perfil,[e.target.name]:e.target.value} )
    };

    const handleChange = (event) => {
        let contador=0                
        for (let index = 0; index < 6; index++) {
            const elemento = listChecks[`opPrec${index+1}`];            
            if (elemento ) {
                contador++
            }    
        }                     
                   
        if ( contador <3 || !event.target.checked ) {             
            setListChecks({ ...listChecks, [event.target.name]: event.target.checked });                                      
        }                
         
    };

    function validaPregunta4(auxCampo) 
    {   let respuesta=false
        if (auxCampo.length>0 ) 
        {                
            respuesta=true                    
        }else
        {            
            mandaAlerta('No se lleno el campo ¿Cuál es tu mayor preocupación?',"warning") 
        }
                
        return respuesta;
    }
 
    function guardarDatos(e)
    {   e.preventDefault()    
        let auxCadena=""
        for (let index = 0; index < 6; index++) {
            const elemento = listChecks[`opPrec${index+1}`];            
            if (elemento ) {
               auxCadena= `${auxCadena}${index+1}|` 
            }    
        }     
        
                    
        if (!verificaNulos(Municipio,"Sección") &&
            !verificaNulos(pregunta1,"¿Conoces a Carlos Zurita?") && !verificaNulos(pregunta2,"¿Votarias por El ?") &&
            !verificaNulos(pregunta3,"¿Votarías por un Candidato nuevo?") && validaPregunta4(auxCadena) &&
            validaVariable(Nombre,'Nombre',3) && //validaVariable(apPat,'Apellido Paterno',3) && validaVariable(apMat,'Apellido Materno',3) && 
            validaVariable(Tel,'Telefono',10) && 
            !verificaNulos(genero,"Genero") && !verificaNulos(edad,"Edad") && !verificaNulos(percepcion,"Percepción"))
        {           
            let nvo=auxCadena.slice(0, auxCadena.length-1) 
            setMensaje('');                
            setAviso(false);               
            setBtnDeshabilitado(true)              
            //console.log(nvo);            
            getNvoPerfil(nvo)                             
        }                                  
    } 
      
    const DatosGenerales=(
        <div>                    
            <Box  mt={1} mb={1} display="flex" flexDirection={"row"}>       
                          
                {listMun.length!==0 ?
                <Autocomplete
                    id="muni-select-nvoPerfil" size='small' style={{ width: '12rem', marginRight:"1rem" }}
                    onChange={(e,option)=>guardarMuni(option)}  value={Municipio}      
                    getOptionLabel={(option) => option.cadena} name="Municipio"             
                    noOptionsText={"Sin coincidencias"} options={listMun}
                    renderInput={(params) => (
                        <TextField {...params} size='small' 
                        label="Sección" variant="outlined" />
                    )} 
                />
                :<LinearProgress/>}       
                  
            </Box>            
            <Typography color='primary'>INFORMACIÓN PROPORCIONADA POR EL ENCUESTADO</Typography>
            <Divider />  
            <FormControl component="fieldset" size='small' style={{marginTop:".5rem"}} >          
                <FormLabel  htmlFor="pregunta1" size='small'>{`¿Conoces a Carlos Zurita?`}</FormLabel>        
                <RadioGroup  row aria-label="position"  defaultValue="top" size='small'
                    name="pregunta1" value={pregunta1} onChange={onChangeCheck}
                >
                    <FormControlLabel value='1'  size='small'
                        control={<Radio color="primary" size='small'/>} label="Si" />    
                    <FormControlLabel value='2'   
                        control={<Radio color="primary" size='small' />} label="No" />                                             
                </RadioGroup>                     
            </FormControl>
            <br/>
            <FormControl component="fieldset" size='small' >          
                <FormLabel  htmlFor="pregunta2" size='small'>{`¿Votarias por El ?`}</FormLabel>        
                <RadioGroup  row aria-label="position"  defaultValue="top" size='small'
                    name="pregunta2" value={pregunta2} onChange={onChangeCheck}
                >
                    <FormControlLabel value='1'  size='small'
                        control={<Radio color="primary" size='small'/>} label="Si Votaría" />    
                    <FormControlLabel value='2'   
                        control={<Radio color="primary" size='small' />} label="Indecisa" />                         
                    <FormControlLabel value='3'   
                        control={<Radio color="primary" size='small' />} label="No Votaría" />                                                                 
                </RadioGroup>                     
            </FormControl>
            <br/>
            <FormControl component="fieldset" size='small' >          
                <FormLabel  htmlFor="pregunta3" size='small'>{`¿Votarías por un Candidato nuevo?`}</FormLabel>        
                <RadioGroup  row aria-label="position"  defaultValue="top" size='small'
                    name="pregunta3" value={pregunta3} onChange={onChangeCheck}
                >
                    <FormControlLabel value='1'  size='small'
                        control={<Radio color="primary" size='small'/>} label="Si" />    
                    <FormControlLabel value='2'   
                        control={<Radio color="primary" size='small' />} label="No" />                                             
                                                             
                </RadioGroup>                     
            </FormControl>     
            <Box style={{width:"41rem"}}>
             <FormControl component="fieldset"  size='small'>
                <FormLabel component="legend" size='small'>¿Cuál es tu mayor preocupación?</FormLabel>
                <FormGroup row size='small'>
                <FormControlLabel size='small'
                    control={<Checkbox checked={opPrec1} onChange={handleChange} name="opPrec1" size='small' />}
                    label="Transporte"
                />
                <FormControlLabel size='small'
                    control={<Checkbox checked={opPrec2} onChange={handleChange} name="opPrec2" size='small' />}
                    label="Seguridad"
                />
                <FormControlLabel size='small'
                    control={<Checkbox checked={opPrec3} onChange={handleChange} name="opPrec3" size='small' />}
                    label="Economía"
                />
                <FormControlLabel size='small'
                    control={<Checkbox checked={opPrec4} onChange={handleChange} name="opPrec4" size='small' />}
                    label="Basura"
                />
                <FormControlLabel size='small'
                    control={<Checkbox checked={opPrec5} onChange={handleChange} name="opPrec5" size='small' />}
                    label="Salud"
                />
                <FormControlLabel size='small'
                    control={<Checkbox checked={opPrec6} onChange={handleChange} name="opPrec6" size='small' />}
                    label="Educación"
                />
                </FormGroup>
                
            </FormControl>
            </Box>                   
            
            <TextField required id="Nombre-input" onChange={onChangeNom} style={{paddingBottom:.5+'rem',width:12+'rem',marginRight:"1.5rem"}}
                label="Nombre" value={Nombre} name='Nombre'size="small" autoComplete='off' // defaultValue="Nombre"                                
            />
            
            <TextField required id="apPat-input" onChange={onChangeNom} style={{paddingBottom:.5+'rem',width:12+'rem',marginRight:"1.5rem"}}
                label="Apellido Paterno" value={apPat} name='apPat'size="small" autoComplete='off' // defaultValue="apPat"                                 
            />

            <TextField required id="apMat-input" onChange={onChangeNom} style={{paddingBottom:1.5+'rem',width:12+'rem'}}
                label="Apellido Materno" value={apMat} name='apMat'size="small" autoComplete='off' // defaultValue="apMat"                            
            />
            <br/>            
            <TextField  id="CInt-input" onChange={onChangeNumTel} style={{width:8+'rem'}}
                label="Teléfono" defaultValue="Tel" value={Tel} name='Tel' size="small" type="number"
                inputProps= {{ maxlength: 10 }} autoComplete='off'
            /> 
            <TextField  id="CInt-calle" onChange={onChangeTxt} style={{width:'25rem', marginLeft:"1rem"}}
                label="Domicilio (Solo si no esta en su domicilio)" defaultValue="calle" value={calle} 
                name='calle' size="small"   autoComplete='off'
            />    
            <br/>       
            <Typography color='primary' style={{marginTop:"1rem"}}>INFORMACIÓN LLENADA POR EL ENCUESTADOR</Typography>
            <Divider />  
            <Box mt={1} display={"flex"} flexDirection={"column"}>               
                <FormControl component="fieldset" size='small' >          
                    <FormLabel  htmlFor="Género" size='small'>Género</FormLabel>        
                    <RadioGroup  row aria-label="position"  defaultValue="top" size='small'
                        name="genero" value={genero} onChange={onChangeGen}
                    >
                        <FormControlLabel value='H'  size='small'
                            control={<Radio color="primary" size='small'/>} label="Hombre" />    
                        <FormControlLabel value='M'   
                            control={<Radio color="primary" size='small' />} label="Mujer" />                         
                        <FormControlLabel value='X'   
                            control={<Radio color="primary" size='small' />} label="No Binario" />                         
                    </RadioGroup>                     
                </FormControl>
                <FormControl component="fieldset" size='small' >          
                    <FormLabel  htmlFor="Edad" size='small'>Edad</FormLabel>        
                    <RadioGroup  row aria-label="position"  defaultValue="top" size='small'
                        name="edad" value={edad} onChange={onChangeCheck}
                    >
                        <FormControlLabel value='1'  size='small'
                            control={<Radio color="primary" size='small'/>} label="18/25" />    
                        <FormControlLabel value='2'   
                            control={<Radio color="primary" size='small' />} label="26/35" />                         
                        <FormControlLabel value='3'   
                            control={<Radio color="primary" size='small' />} label="36/45" />                         
                        <FormControlLabel value='4'   
                            control={<Radio color="primary" size='small' />} label="46/100" />                         
                    </RadioGroup>                     
                </FormControl>
                <FormControl component="fieldset" size='small' >          
                    <FormLabel  htmlFor="percepcion" size='small'>Percepción</FormLabel>        
                    <RadioGroup  row aria-label="position"  defaultValue="top" size='small'
                        name="percepcion" value={percepcion} onChange={onChangeCheck}
                    >
                        <FormControlLabel value='1'  size='small'
                            control={<Radio color="primary" size='small'/>} label="Buena" />    
                        <FormControlLabel value='2'   
                            control={<Radio color="primary" size='small' />} label="Indecisa" />                         
                        <FormControlLabel value='3'   
                            control={<Radio color="primary" size='small' />} label="Mala" />                                                                 
                    </RadioGroup>                     
                </FormControl>
            </Box>                             
        </div> 
    )     

    const cerrarBorrar = () => {            
        setAviso(false);
        setModalAbierto(false);
        if (cambioEfectivo) 
        {  
          setNvoRegisPerfil({Nom:Nombre,llave:nvoRegistro.mensaje})                                   
        }
    };
       
    return (           
    <Modal
        titulo={titulo} modalAbierto={modalAbierto}
        setModalAbierto={setModalAbierto} guardarDatos={guardarDatos}
        mensaje={mensaje} tipoAdvertencia={tipoAdvertencia}
        aviso={aviso} btnDeshabilitado={btnDeshabilitado}
        setAviso={setAviso} tamanio={'md'} cargando={espera}     
        cerrarBorrar={cerrarBorrar}   btnLeyenda={btnLeyenda}
    >      
        {DatosGenerales}
    </Modal>             
    )
}

export default ModalPerfilv2